import type { TimeSeriesPoint, PerformanceSummary } from "@/types/performance"

function periodToDays(period: string): number {
	const now = new Date()
	switch (period) {
		case "1W":
			return 7
		case "1M":
			return 30
		case "3M":
			return 90
		case "6M":
			return 180
		case "YTD": {
			const startOfYear = new Date(now.getFullYear(), 0, 1)
			return Math.floor((now.getTime() - startOfYear.getTime()) / 86400000)
		}
		case "1Y":
			return 365
		case "ALL":
			return 730
		default:
			return 30
	}
}

export function generateDemoPerformance(period: string = "1M"): {
	timeseries: TimeSeriesPoint[]
	summary: PerformanceSummary
} {
	const days = Math.max(periodToDays(period), 1)
	const startValue = 48000
	const dividendsReceived = 2150

	// Walk forward day-by-day with slightly positive bias
	const now = new Date()
	const points: TimeSeriesPoint[] = []
	let value = startValue

	for (let i = days; i >= 0; i--) {
		const date = new Date(now)
		date.setDate(date.getDate() - i)
		const dateStr = date.toISOString().slice(0, 10)

		if (i < days) {
			// Apply random daily return with slight positive bias
			const dailyReturn = (Math.random() - 0.49) * 0.016
			value = value * (1 + dailyReturn)
		}

		points.push({ date: dateStr, value: Math.round(value * 100) / 100 })
	}

	const currentValue = points[points.length - 1].value
	const periodStartValue = points[0].value
	const periodReturn = currentValue - periodStartValue
	const periodReturnPct = periodStartValue > 0 ? (periodReturn / periodStartValue) * 100 : 0
	const unrealizedGain = periodReturn
	const unrealizedGainPct = periodReturnPct
	const totalReturn = unrealizedGain + dividendsReceived
	const totalReturnPct = periodStartValue > 0 ? (totalReturn / periodStartValue) * 100 : 0

	const summary: PerformanceSummary = {
		current_value: currentValue,
		cost_basis: 0,
		unrealized_gain: unrealizedGain,
		unrealized_gain_pct: unrealizedGainPct,
		dividends_received: dividendsReceived,
		total_return: totalReturn,
		total_return_pct: totalReturnPct,
		period_start_value: periodStartValue,
		period_end_value: currentValue,
		period_return: periodReturn,
		period_return_pct: periodReturnPct,
		top_movers: [
			{ ticker: "AAPL", exchange: "NASDAQ", name: "Apple Inc.", change_pct: 8.42, change_abs: 18.5 },
			{ ticker: "MSFT", exchange: "NASDAQ", name: "Microsoft Corp.", change_pct: 5.17, change_abs: 22.1 },
			{ ticker: "PEP", exchange: "NASDAQ", name: "PepsiCo Inc.", change_pct: 3.21, change_abs: 5.8 },
			{ ticker: "T", exchange: "NYSE", name: "AT&T Inc.", change_pct: -4.55, change_abs: -0.82 },
			{ ticker: "DIS", exchange: "NYSE", name: "Walt Disney Co.", change_pct: -2.88, change_abs: -2.65 },
		],
		currency: "USD",
	}

	return { timeseries: points, summary }
}
